<template>
  <div class="s-playing-now__options__filters">
    <div class="s-playing-now__options__filters__element">
      <select
        id="roomTypes"
        class="form-select"
        :class="{ 'form-select--mobile': !desktop }"
        :value="modelValue.roomTypes"
        :disabled="roomTypesOptions.length === 0"
        @change="(e) => onChangeRoomTypes(e)">
        <option value="All" selected>
          {{ dictionary.placeholderRoomType }}
        </option>
        <option
          v-for="option in roomTypesOptions"
          :key="option.value"
          :value="option.value">
          {{ option.display }}
        </option>
      </select>
    </div>

    <div class="s-playing-now__options__filters__element">
      <select
        id="screenTypes"
        class="form-select"
        :class="{ 'form-select--mobile': !desktop }"
        :value="modelValue.screenTypes"
        :disabled="screenTypesOptions.length === 0"
        @change="(e) => onChangeScreenTypes(e)">
        <option value="All" selected>
          {{ dictionary.placeholderScreenType }}
        </option>
        <option
          v-for="option in screenTypesOptions"
          :key="option.value"
          :value="option.value">
          {{ option.display }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue'
import useViewport from '../../features/viewport.js'
import constants from './../../lib/constants'

const { dictionary } = getCurrentInstance().appContext.config.globalProperties

const { desktop } = useViewport()

// props
defineProps({
  roomTypesOptions: {
    default() {
      return []
    },
    type: Array,
    required: true,
  },

  screenTypesOptions: {
    default() {
      return []
    },
    type: Array,
    required: true,
  },

  modelValue: {
    default() {
      return null
    },
    type: Object,
  },
})

// emits
const emit = defineEmits(['filter-changed'])

const onChangeRoomTypes = (e) => {
  const value = e.target.value
  emit('filter-changed', value, constants.filters.roomTypes)
}

const onChangeScreenTypes = (e) => {
  const value = e.target.value
  emit('filter-changed', value, constants.filters.screenTypes)
}
</script>
